import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import HotRecommendSection from './components/HotRecommendSection';
import CategoryEntrySection from './components/CategoryEntrySection';
import LatestUpdateSection from './components/LatestUpdateSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <HotRecommendSection />
        <CategoryEntrySection />
        <LatestUpdateSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}